import Loadable from 'react-loadable';
import Loading from './../components/loading';
import HomeRouteConfig from './pageMap/home';
import ImageTextManageRouteConfig from './pageMap/imageTextManange';
import RankingManageConfig from './pageMap/rankingManage';
import DataManageConfig from './pageMap/dataManage';

import AccountManageConfig from './pageMap/accountMange';
import resolveComponent from './resolveComponent';
import AIWriterConfig from './pageMap/aiWriter'
export * from './pageMap/home';
export * from './pageMap/imageTextManange';
export * from './pageMap/rankingManage';
export * from './pageMap/accountMange';

const RouteConfig = [
    ...HomeRouteConfig,
    ...ImageTextManageRouteConfig,
    ...AIWriterConfig,
    ...RankingManageConfig,
    ...AccountManageConfig,
    ...DataManageConfig,
    {
        path: '/:appId?/offiaccount',
        exact: false,
        label: '公众号列表',
        component: resolveComponent(() => import('@src/service')),
        children: [{
            path: '/:appId?/offiaccount/list',
            exact: true,
            label: '公众号列表',
            code: 'ARTICLE-ACCOUNT',
            component: resolveComponent(() => import('@src/pages/app/imageTextManage/offiaccount/list')),
        },]

    },
    {
        path: '/:appId?/accountswitch',
        exact: true,
        label: '公众号管理',
        component:resolveComponent(() => import('@src/service')),
        children: [{
            path: '/:appId?/accountswitch',
            exact: true,
            label: '公众号列表',
            component: Loadable({ loader: () => import('./../pages/cardList'), loading: Loading })
        },
        
    ]
    },
    {
        path: '/:appId?/app/manage',
        exact: true,
        label: '应用管理',
        component: Loadable({ loader: () => import('./../service'), loading: Loading }),
        children: [{
            path: '/:appId?/app/manage',
            exact: true,
            label: '应用管理',
            component: Loadable({ loader: () => import('./../pages/appList'), loading: Loading })
        },]
    },
    {
        path: '/:appId/app/bind',
        exact: true,
        label: '中控管理',
        component: Loadable({ loader: () => import('./../service'), loading: Loading }),
        children: [{
            path: '/:appId/app/bind',
            exact: true,
            label: '中控管理',
            component: Loadable({ loader: () => import('./../components/appList'), loading: Loading })
        },]
       
    },
    {
        path: '/:appId/detail',
        label: 'detail',
        exact: false,
        component: Loadable({ loader: () => import('./../service'), loading: Loading }),
        children: [{
            path: '/:appId/detail/basic/autoreply',
            exact: true,
            label: '自动回复',
            code: 'detail-basic-autoreply',
            component: Loadable({ loader: () => import('./../components/basic/autoReply'), loading: Loading })
        },
        {
            path: '/:appId/detail/basic/autoreply/form/:id?',
            exact: true,
            label: '新建回复',
            component: Loadable({ loader: () => import('./../components/basic/autoReply/form'), loading: Loading })
        },
        {
            path: '/:appId/detail/basic/menu',
            exact: true,
            label: '自定义菜单',
            component: Loadable({ loader: () => import('./../components/basic/menu'), loading: Loading })
        },
        {
            path: '/:appId/detail/basic/qrcode',
            exact: true,
            label: '带参二维码',
            code: 'detail-basic-qrcode',
            component: Loadable({ loader: () => import('./../components/basic/qrcode'), loading: Loading })
        },
        {
            path: '/:appId/detail/basic/qrcode/count/:id',
            exact: true,
            label: '二维码统计',
            code: 'detail-basic-qrcode',
            component: Loadable({ loader: () => import('./../components/basic/qrcode/count'), loading: Loading })
        },
        {
            path: '/:appId/detail/fans/list',
            exact: true,
            label: '粉丝列表',
            code: 'detail-fans-list',
            component: Loadable({ loader: () => import('./../components/fansList'), loading: Loading })
        },
        {
            path: '/:appId/detail/fans/list/:openid',
            exact: true,
            label: '粉丝详情',
            code: 'detail-fans-list',
            component: Loadable({ loader: () => import('./../components/fansDetail'), loading: Loading })
        },
        {
            path: '/:appId/detail/basic/qrcode/form/:id?',
            exact: true,
            label: '新建二维码',
            code: 'detail-basic-qrcode',
            component: Loadable({ loader: () => import('./../components/basic/qrcode/form'), loading: Loading })
        },
        {
            path: '/:appId/detail/tags',
            exact: true,
            label: '标签列表',
            code: 'detail-tags',
            component: Loadable({ loader: () => import('./../components/tagsList'), loading: Loading })
        },
        {
            path: '/:appId/detail/tags/detail/:weixinTag',
            exact: true,
            label: '标签规则列表',
            component: Loadable({ loader: () => import('./../components/tagsRuleList'), loading: Loading })
        },
        {
            path: '/:appId/detail/msg/group',
            exact: true,
            label: '高级群发',
            code: 'detail-msg-group',
            component: Loadable({ loader: () => import('./../components/groupMsgList'), loading: Loading })
        },
        {
            path: '/:appId/detail/msg/template',
            exact: true,
            label: '模板群发',
            code: 'detail-msg-group',
            component: Loadable({ loader: () => import('./../components/templateMsgList'), loading: Loading })
        },
        {
            path: '/:appId/detail/msg/template/record/:id',
            exact: true,
            label: '发送记录',
            code: 'detail-msg-group',
            component: Loadable({ loader: () => import('./../components/templateMsgList/record'), loading: Loading })
        },
        {
            path: '/:appId/detail/msg/48hours',
            exact: true,
            label: '48小时流',
            component: Loadable({ loader: () => import('./../components/48hoursMsgList'), loading: Loading })
        },
        {
            path: '/:appId/detail/msg/48hours/form/:id?',
            exact: true,
            label: '新建推送任务',
            component: Loadable({ loader: () => import('./../components/48hoursMsgList/form'), loading: Loading })
        },
        {
            path: '/:appId/detail/msg/group/form',
            exact: true,
            label: '新建高级群发',
            code: 'detail-msg-group',
            component: Loadable({ loader: () => import('./../components/groupMsgList/form'), loading: Loading })
        },
        {
            path: '/:appId/detail/msg/template/form/:copyId?',
            exact: true,
            label: '新建模板消息',
            code: 'detail-msg-group',
            component: Loadable({ loader: () => import('./../components/templateMsgList/form'), loading: Loading })
        },
        {
            path: '/:appId/detail/activity/list',
            exact: true,
            label: '任务宝裂变',
            component: Loadable({ loader: () => import('./../components/activityList'), loading: Loading })
        },
        {
            path: '/:appId/detail/activity/template',
            exact: true,
            label: '模板库',
            component: Loadable({ loader: () => import('./../components/activityTemplate'), loading: Loading })
        },
        {
            path: '/:appId/detail/activity/template/dataList/:id',
            exact: true,
            label: '模板数据',
            component: Loadable({ loader: () => import('./../components/activityTemplate/dataList'), loading: Loading })
        },
        {
            path: '/:appId/detail/activity/static/:id/:formId?',
            exact: true,
            label: '数据统计',
            component: Loadable({ loader: () => import('./../components/activityList/static'), loading: Loading })
        },
        {
            path: '/:appId/detail/activity/form/:id?',
            exact: true,
            label: '新建活动',
            component: Loadable({ loader: () => import('./../components/activityList/form'), loading: Loading })
        },
        ]

    },
    {
        path: '/',
        label: 'index',
        exact: false,
        component: Loadable({ loader: () => import('./../service'), loading: Loading }),
        children: [
            {
                path: '/app',
                exact: true,
                label: '应用管理',
                code: 'app',
                component: Loadable({ loader: () => import('./../pages/appList'), loading: Loading })
            },
            {
                path: '/account/form/:setAppId?',
                exact: true,
                label: '绑定公众号',
                component: Loadable({ loader: () => import('./../pages/accountForm'), loading: Loading })
            },
            {
                path: '/account/set/:setAppId?',
                exact: true,
                label: '公众号信息',
                component: Loadable({ loader: () => import('./../pages/accountDetail'), loading: Loading })
            },
            {
                path: '/app/permission/:callerId',
                exact: true,
                component: Loadable({ loader: () => import('./../pages/permissionList'), loading: Loading })
            }
        ]
    },

];

export default RouteConfig;